import React from 'react'

const Manual_beneficios_etiquetas = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold text-4xl text-[#002D33] mb-5">
          Crear beneficios con etiquetas
        </h2>
        <iframe
          src="https://scribehow.com/embed/Crear_beneficios_con_etiquetas__S-R36i6_SGaGm0mKS0kpxw?as=scrollable"
          className="scribe-iframe-general-138"
          width="100%"
          height="9100"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_beneficios_etiquetas
